import { Row, Element, Story } from '../store/Entities/Stories/stories.reducer';
import {
  find,
  propEq,
  filter,
  indexOf,
  map,
  toUpper,
  head,
  merge,
  reduce,
  forEach,
  reject,
  assoc,
} from 'ramda';

export interface Country {
  name: string;
  shortcode: string;
  id: number;
  baseUrl: string;
  timeZone: string;
}

/**
 * ###########################################################
 *
 * ATTENTION: When adding countries to this list,
 *            make sure to also check the LANGUAGE_GROUPS
 *            beneath this list!
 *
 * ###########################################################
 */

export const countries: Country[] = [
  {
    name: 'Germany',
    shortcode: 'de',
    id: 139,
    baseUrl: 'https://www.aboutyou.de',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Austria',
    shortcode: 'at',
    id: 200,
    baseUrl: 'https://www.aboutyou.at',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Switzerland',
    shortcode: 'ch',
    id: 431,
    baseUrl: 'https://www.aboutyou.ch',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Netherlands',
    shortcode: 'nl',
    id: 545,
    baseUrl: 'https://www.aboutyou.nl',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Belgium (nl)',
    shortcode: 'nl_be',
    id: 558,
    baseUrl: 'https://www.aboutyou.be',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Belgium (fr)',
    shortcode: 'fr_be',
    id: 562,
    baseUrl: 'https://fr.aboutyou.be',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Switzerland (FR)',
    shortcode: 'fr_ch',
    id: 566,
    baseUrl: 'https://m-fr.aboutyou.ch',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Poland',
    shortcode: 'pl_PL',
    id: 550,
    baseUrl: 'https://m.aboutyou.pl',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Czech Republic',
    shortcode: 'cs_CZ',
    id: 554,
    baseUrl: 'https://m.aboutyou.cz',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Romania',
    shortcode: 'ro_RO',
    id: 594,
    baseUrl: 'https://m.aboutyou.ro',
    timeZone: 'Europe/Bucharest',
  },
  {
    name: 'Hungary',
    shortcode: 'hu_HU',
    id: 590,
    baseUrl: 'https://m.aboutyou.hu',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Slovakia',
    shortcode: 'sk_SK',
    id: 586,
    baseUrl: 'https://m.aboutyou.sk',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Slovenia',
    shortcode: 'sl_SI',
    id: 617,
    baseUrl: 'https://m.aboutyou.si',
    timeZone: 'Europe/Ljubljana',
  },
  {
    name: 'Latvia',
    shortcode: 'lv_LV',
    id: 622,
    baseUrl: 'https://m.aboutyou.lv',
    timeZone: 'Europe/Riga',
  },
  {
    name: 'Lithuania',
    shortcode: 'lt_LT',
    id: 627,
    baseUrl: 'https://m.aboutyou.lt',
    timeZone: 'Europe/Vilnius',
  },
  {
    name: 'Estonia',
    shortcode: 'et_EE',
    id: 632,
    baseUrl: 'https://m.about-you.ee',
    timeZone: 'Europe/Tallinn',
  },
  {
    name: 'Croatia',
    shortcode: 'hr_HR',
    id: 637,
    baseUrl: 'https://m.about-you.hr',
    timeZone: 'Europe/Zagreb',
  },
  {
    name: 'Bulgaria',
    shortcode: 'bg_BG',
    id: 642,
    baseUrl: 'https://m.aboutyou.bg',
    timeZone: 'Europe/Sofia',
  },
  {
    name: 'Denmark',
    shortcode: 'da_DK',
    id: 654,
    baseUrl: 'https://m-dk.aboutyou.com',
    timeZone: 'Europe/Copenhagen',
  },
  {
    name: 'Sweden',
    shortcode: 'sv_SE',
    id: 655,
    baseUrl: 'https://m-se.aboutyou.com',
    timeZone: 'Europe/Stockholm',
  },
  {
    name: 'Finland',
    shortcode: 'fi_FI',
    id: 656,
    baseUrl: 'https://m-fi.aboutyou.com',
    timeZone: 'Europe/Helsinki',
  },
  {
    name: 'France',
    shortcode: 'fr_FR',
    id: 658,
    baseUrl: 'https://m.aboutyou.fr',
    timeZone: 'Europe/Paris',
  },
  {
    name: 'Spain',
    shortcode: 'es_ES',
    id: 670,
    baseUrl: 'https://m.aboutyou.es',
    timeZone: 'Europe/Madrid',
  },
  {
    name: 'Italy',
    shortcode: 'it_IT',
    id: 671,
    baseUrl: 'https://m.aboutyou.it',
    timeZone: 'Europe/Rome',
  },
  {
    name: 'Portugal',
    shortcode: 'pt_PT',
    id: 685,
    baseUrl: 'https://m.aboutyou.pt',
    timeZone: 'Europe/Lisbon',
  },
  {
    name: 'Greece',
    shortcode: 'el_GR',
    id: 686,
    baseUrl: 'https://m.aboutyou.gr',
    timeZone: 'Europe/Athens',
  },
  {
    name: 'Germany (en)',
    shortcode: 'en_DE',
    id: 688,
    baseUrl: 'https://m-en.aboutyou.de',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Global (en)',
    shortcode: 'en_ZZ',
    id: 692,
    baseUrl: 'https://m.aboutyou.com',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Global (es)',
    shortcode: 'es_ZZ',
    id: 693,
    baseUrl: 'https://m-es.aboutyou.com',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Cyprus (EL)',
    shortcode: 'el_CY',
    id: 705,
    baseUrl: 'https://aboutyou.com.cy',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Luxembourg (FR)',
    shortcode: 'fr_LU',
    id: 706,
    baseUrl: 'https://www.aboutyou.lu',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Switzerland (IT)',
    shortcode: 'it_CH',
    id: 715,
    baseUrl: 'https://m-it.aboutyou.ch',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Estonia (RU)',
    shortcode: 'ru_EE',
    id: 716,
    baseUrl: 'https://ru.aboutyou.ee',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Latvia (RU)',
    shortcode: 'ru_LV',
    id: 717,
    baseUrl: 'https://ru.aboutyou.lv',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Switzerland (EN)',
    shortcode: 'en_CH',
    id: 730,
    baseUrl: 'https://m-en.aboutyou.ch',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Austria (EN)',
    shortcode: 'en_AT',
    id: 731,
    baseUrl: 'https://m-en.aboutyou.at',
    timeZone: 'Europe/Berlin',
  },
  {
    name: 'Netherlands (EN)',
    shortcode: 'en_NL',
    id: 732,
    baseUrl: 'https://m-en.aboutyou.nl',
    timeZone: 'Europe/Berlin',
  },
];

/**
 * Please always add new locales in ISO-639 + ISO-3166 with underscore.
 * Correct: fr_CH
 * Incorrect: fr
 */
export const LANGUAGE_GROUPS = [
  ['de', 'at', 'ch'],
  ['nl', 'nl_be'],
  ['fr_be', 'fr_ch', 'fr_FR', 'fr_LU'],
  ['pl_PL'],
  ['cs_CZ'],
  ['ro_RO'],
  ['hu_HU'],
  ['sk_SK'],
  ['sl_SI'],
  ['lv_LV'],
  ['lt_LT'],
  ['et_EE'],
  ['hr_HR'],
  ['bg_BG'],
  ['en_DE', 'en_ZZ', 'en_AT', 'en_CH', 'en_NL'],
  ['da_DK'],
  ['sv_SE'],
  ['fi_FI'],
  ['es_ES', 'es_ZZ'],
  ['it_IT', 'it_CH'],
  ['pt_PT'],
  ['el_GR', 'el_CY'],
  ['ru_LV', 'ru_EE'],
];

export function countryById(appId: number): Country {
  const country = find(propEq('id', appId))(countries);
  if (!country) {
    throw `A country with the appId of ${appId} doesn't exist!`;
  }

  return country as Country;
}

export function getCountriesByIds(appIds: number[]): Country[] {
  return filter(
    (country: Country) => indexOf(country.id, appIds) > -1,
    countries
  );
}

export function countryByShortcode(shortcode: string): Country {
  return (
    (find(propEq('shortcode', shortcode))(countries) as Country) || countries[0]
  );
}

export function getCountryIdByShortcode(shortcode?: string): number {
  if (!shortcode) {
    return countries[0].id;
  }
  const country = countryByShortcode(shortcode);
  return country && country.id;
}

export function getShortcodesByIds(appIds: number[]) {
  const appCountries = getCountriesByIds(appIds);
  return map((country: Country) => toUpper(country.shortcode), appCountries);
}

export function getShortcodeById(appId: number) {
  if (!appId) {
    return '';
  }
  return head(getShortcodesByIds([appId]));
}

export function fillEmptyElementTextsWithGerman(rows: Row[]): Row[] {
  return map((item: Row) => {
    const { type, elements } = item;
    if (type !== 'text' && type !== 'headline') {
      return item;
    }

    return {
      ...item,
      elements: map((element: Element) => {
        const { text } = element;
        if (!text) {
          return element;
        }

        return merge(element, {
          text: fillTranslatableWithFallback('de', text.de, text),
        });
      }, elements),
    };
  }, rows);
}

function fillTextForLanguagegroup(text: Element['text'], countryCode: string) {
  const languageGroup = LANGUAGE_GROUPS.find(g => g.includes(countryCode));

  if (!text || !languageGroup) {
    return text;
  }

  const isFirstTranslationOfLanguageGroup =
    Object.keys(text).reduce(
      (acc, cur) => (languageGroup.includes(cur) ? acc + 1 : acc),
      0
    ) < 2;

  if (!isFirstTranslationOfLanguageGroup) {
    return text;
  }

  return {
    ...text,
    ...languageGroup.reduce(
      (acc, cur) => ({ ...acc, [cur]: text[countryCode] }),
      {}
    ),
  };
}

/**
 * Prefill translations for all rows of type 'headline' and 'text'
 * for the language group of the countryCode provided.
 * This will only happen, if its the first translation of a language group.
 */
export function fillEmptyElementTextsForLanguageGroupOfCountry(
  rows: Row[],
  countryCode: string
): Row[] {
  return rows.map((row: Row) => {
    const { type, elements } = row;

    if (!['text', 'headline', 'layout'].includes(type)) {
      return row;
    }

    return {
      ...row,
      elements: elements.map(element => ({
        ...element,
        text: fillTextForLanguagegroup(element.text, countryCode),
      })),
    };
  });
}

export function fillEmptyHeaderTextsWithGerman(story: Story): Story {
  const { headline, subline, headlineLong, sublineLong } = story;
  let result = story;
  if (headline && typeof headline === 'object') {
    const { de: headlineDe, at: headlineAt, ch: headlineCh } = headline as {
      [key: string]: string;
    };

    result = merge(result, {
      headline: {
        de: headlineDe,
        at: headlineAt || headlineDe,
        ch: headlineCh || headlineDe,
      },
    });
  }
  if (subline && typeof subline === 'object') {
    const { de: sublineDe, at: sublineAt, ch: sublineCh } = subline as {
      [key: string]: string;
    };
    result = merge(result, {
      subline: {
        de: sublineDe,
        at: sublineAt || sublineDe,
        ch: sublineCh || sublineDe,
      },
    });
  }
  if (headlineLong && typeof headlineLong === 'object') {
    const { de: headlineLongDe, at: headlineLongAt, ch: headlineLongCh } = headlineLong as {
      [key: string]: string;
    };

    result = merge(result, {
      headlineLong: {
        de: headlineLongDe,
        at: headlineLongAt || headlineLongDe,
        ch: headlineLongCh || headlineLongDe,
      },
    });
  }
  if (sublineLong && typeof sublineLong === 'object') {
    const { de: sublineLongDe, at: sublineLongAt, ch: sublineLongCh } = sublineLong as {
      [key: string]: string;
    };
    result = merge(result, {
      sublineLong: {
        de: sublineLongDe,
        at: sublineLongAt || sublineLongDe,
        ch: sublineLongCh || sublineLongDe,
      },
    });
  }

  return result;
}

export function fillEquallySpokenTranslatables(
  languageShortcode: string,
  text: string
): { [key: number]: string } {
  return reduce(
    (carrier, item) => {
      if (
        languageShortcode === item.shortcode ||
        item.shortcode.indexOf(languageShortcode) > -1
      ) {
        carrier[item.shortcode] = text;
      }
      return carrier;
    },
    {} as { [key: number]: string },
    countries
  );
}

export function fillTranslatableWithFallback(
  initialShortcode: string,
  initialText: string,
  actual: { [key: number]: string }
): { [key: number]: string } {
  let res = { [initialShortcode]: initialText };
  forEach(
    (country: Country) =>
      (res = assoc(
        country.shortcode,
        actual[country.shortcode] || initialText,
        res
      )),
    reject(country => country.shortcode === initialShortcode, countries)
  );
  return res;
}

export function getBaseUrlForShortcode(shortcode: string): string {
  const country = countryByShortcode(shortcode);
  if (!country) {
    return '';
  }

  return country.baseUrl;
}



// WEBPACK FOOTER //
// ./src/utils/country.ts